import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { FunctionComponent } from "react";
import { AlertDialogHeader, AlertDialogFooter } from "./ui/alert-dialog";

interface DialogAlertBlockerProps {
  shouldBlock: boolean;
  proceed: () => void;
  cancel: () => void;
}

const DialogAlertBlocker: FunctionComponent<DialogAlertBlockerProps> = ({
  shouldBlock,
  proceed,
  cancel,
}) => {
  return (
    <AlertDialog open={shouldBlock}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved Changes</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to close?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={cancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={proceed}>Close</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DialogAlertBlocker;
